import { fetchWithSupabaseAuth } from "./supabaseClient.js";

export async function employeeAccountRequest(path = "", { method = "GET", body, confirmSharedIdentity = false } = {}) {
  const response = await fetchWithSupabaseAuth(`/api/driver-accounts/employees${path}`, {
    method, headers: { "Content-Type": "application/json", ...(confirmSharedIdentity ? { "X-Grain-Confirm-Shared-Identity": "true" } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload?.detail?.message || payload?.detail || "L'opération sur le compte chauffeur a échoué.");
  return payload;
}
